import React, { useState, useEffect, useContext, useCallback, useRef } from 'react'
import AppContext from '../../../contexts/AppContext'
import { Link } from 'react-router-dom'
import moment from "moment"
import Header from '../../Header'
import Breadcrumbs from '../../Breadcrumbs'
import Footer from '../../Footer'
import { breadcrumbsBy } from '../../../services/locations'
import nl2br from 'react-nl2br'
import { ReportUserDialog } from '../../UI'
import { truncateString } from '../../../services/posts'
import { userNameFrom, avatarFrom } from '../../../services/users'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFlag, faEllipsisH } from '@fortawesome/free-solid-svg-icons'

import { Helmet } from "react-helmet-async";

import useToastContext from "../../../hooks/useToastContext";

const Threadable = ({ item, type, user }) => {
    type = type?.replaceAll('\\', '-')
    if(!item) return null

    const isThreadableWatched = item?.is_watched && user.type == 'admin'

    if(type == 'App-Post'){
        return (
            <div className="">
                <div className="mb-2">
                    {(
                        item?.data?.images?.length > 0
                        && item?.data?.images[0]
                    ) ? (
                        <a href={'/p/' + item.post_id}>
                            <img
                                className="img-fluid"
                                alt={item.title}
                                src={item.data.images[0]}
                            />
                        </a>
                    ) : (
                        <div className="card-img-bg no-image text-center"><i className="fa fa-camera"></i></div>
                    )}
                </div>
                <div>
                    <h5 className="font-weight-bold">
                        {item.title}
                        {isThreadableWatched && <span className="ms-2 badge bg-danger rounded-pill">Watched</span>}
                    </h5>
                </div>
                <div>
                    <a
                        href={'/p/' + item.post_id}
                        className="btn btn-outline-primary me-1 mb-1"
                    >Show Details</a>
                </div>
            </div>
        )
    }
    if(type == 'App-Banner'){
        return (
            <div className="">
                <div>
                    <h5 className="font-weight-bold">Banner: {item.title ? item.title : item.id}</h5>
                </div>
                <div>
                    <a
                        href={'/account/banner/view/' + item.id}
                        className="btn btn-outline-primary"
                    >Show Details</a>
                </div>
            </div>
        )
    }
    if(type == 'App-Feedback'){
        return (
            <div className="">
                <div>
                    <h5 className="font-weight-bold">Feedback message:</h5>
                    <p>{nl2br(item.message)}</p>
                </div>
            </div>
        )
    }
    if(type == 'App-Company'){
        const addressFrom = obj => obj ? [obj.address, obj.location?.name, obj.postal_code].filter(item => !!item).join(', ') : ''
        const address = item.address && item.address.same_as != 'business_address'
            ? addressFrom(item.address)
            : addressFrom(item.business_address)
        const image = item?.meta?.image
            ? item.meta.image?.urls['500_500']
            : null
        const url = item?.meta?.url
        return (
            <div className="">
                <div>
                    <h5 className="font-weight-bold">
                        <span className="me-2">Business Profile: {item.name}</span>
                        <span
                            className={'badge badge-' + (
                                [1].includes(item.status) ? 'success'
                                : [2].includes(item.status) ? 'danger'
                                : [3].includes(item.status) ? 'warning'
                                : 'primary'
                            )}
                        >{item.status_text}</span>
                    </h5>
                    {image ? (
                        <p>
                            <a href={url}>
                                <img
                                    className="img-fluid"
                                    alt={item.title}
                                    src={image}
                                />
                            </a>
                        </p>
                    ) : (
                        <p className="card-img-bg no-image text-center"><i className="fa fa-camera"></i></p>
                    )}
                    {item.description && <p>{nl2br(truncateString(item.description, 300))}</p>}
                    {address && <p>{address}</p>}
                    {user.id == item.user_id &&
                        <p>
                            <Link tag="a" to="/account/business-profile">Edit Business Profile</Link>
                        </p>
                    }
                    <p><a href={'/profile/' + item.user?.str_id}>Link to company profile</a></p>
                </div>
            </div>
        )
    }
    if(type == 'App-User'){
        return (
            <div className="">
                <div>
                    <h5 className="font-weight-bold">{item.full_name}</h5>
                    <p>User related messages.</p>
                </div>
            </div>
        )
    }
    return null
}

const Message = ({ userId, message }) => {

    const { data } = useContext(AppContext)
    const user = data?.app?.user
    const isOwn = userId == message.user_id

    if(isOwn) {
        return (
            <div className="text-right">
                <small>{moment(message.created_at).fromNow()}</small>
                <div className="d-flex justify-content-end overflow-hidden">
                    <div className="bg-secondary rounded d-inline-block text-white px-2 py-1">
                        {message.body}
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div>
                <small>{moment(message.created_at).fromNow()}</small>
                <div className="d-flex justify-content-start overflow-hidden">
                    <div className="bg-gray-light rounded d-inline-block px-2 py-1">
                        {message.body}
                    </div>
                </div>
            </div>
        )
    }
}

const MessageForm = ({ id, onChange }) => {

    const [ loading, setLoading ] = useState(false)
    const [ message, setMessage ] = useState('')

    const { data } = useContext(AppContext)

    const { messageServices } = useContext(AppContext)
    const addToast = useToastContext()

    const send = e => {
        e.preventDefault()
        setLoading(true)
        messageServices.update(id, message).then(res => {
            setLoading(false)
            setMessage('')
            onChange()
        }).catch(err => {
            addToast({ type: 'danger', title: 'Error', message: err?.data?.message ? err.data.message : 'Something went wrong' })
            setLoading(false)
            setMessage('')
        })
    }

    return (
        <form
            className="d-flex pe-3"
            onSubmit={send}
        >
            <div className="flex-grow-1">
                <input
                    className="form-control shadow-none"
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                />
            </div>
            <div>
                <button
                    disabled={message.length < 2}
                    type="submit"
                    className="btn btn btn-success ms-2"
                >
                    Send
                </button>
            </div>
        </form>
    )
}

const UserContextMenu = ({ id }) => {

    const reportUserDialogRef = useRef()

    return (
        <>
            <div className="dropdown">
                <button className="btn btn-secondary" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                    <FontAwesomeIcon icon={faEllipsisH} />
                </button>
                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                    <a className="dropdown-item" href="" onClick={e => {
                        e.preventDefault();
                            reportUserDialogRef.current.modalDialog({
                                title: 'Report this user'
                            }).then(() => {
                                //console.log('here')
                            }).catch(() => {
                                //console.log('cancel')
                            })
                         }}>
                        <FontAwesomeIcon icon={faFlag} className="me-2" />
                        Report
                    </a>
                </div>
            </div>
            <ReportUserDialog id={id} ref={reportUserDialogRef} />
        </>
    )
}

const ThreadMessages = ({ id }) => {

    const [ thread, setThread ] = useState(null)
    const [ loading, setLoading ] = useState(false)
    const [ updatedAt, setUpdatedAt ] = useState()

    const { data } = useContext(AppContext)
    const user = data?.app?.user

    const hasParticipant = thread?.participants?.filter(item => item.user_id != user?.id).length > 0
    const participant = !thread ? null : (
        hasParticipant
        ? thread?.participants?.filter(item => item.user_id != user?.id)[0].user
        : thread.participants[0].user
    )

    const avatar = avatarFrom(participant)
    const userName = userNameFrom(participant)

    const { messageServices } = useContext(AppContext)
    const addToast = useToastContext()

    const messages = thread?.messages ? thread.messages : []
    const threadable = thread?.threadable ? thread.threadable : null

    const isUserWatched = participant?.is_watched && user.type == 'admin'
    const manageUserUrl = (user.type == 'admin' && participant) ? ('/admin/resources/users/' + participant.id) : null

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        setLoading(true)
        messageServices.show(id).then(res => {
            setThread(res.thread)
            setLoading(false)
            setUpdatedAt(Date.now())
        }).catch(err => {
            addToast({ type: 'danger', title: 'Error', message: err?.data?.message ? err.data.message : 'Something went wrong' })
            setLoading(false)
        })
    }

    const [ height, setHeight ] = useState()
    const [ hHeight, setHHeight ] = useState()
    const [ fHeight, setFHeight ] = useState()

    const div = useCallback(node => node !== null && setHeight(node.getBoundingClientRect().height), []);
    const divHeader = useCallback(node => node !== null && setHHeight(node.getBoundingClientRect().height), []);
    const divFooter = useCallback(node => node !== null && setFHeight(node.getBoundingClientRect().height), []);
    const messagesEndRef = useRef()

    useEffect(() => {
        if(messagesEndRef.current){
            messagesEndRef.current.scrollIntoView({block: 'end'})
        }
    }, [ height, hHeight, fHeight, updatedAt ]);

    return (

        <div className="tread-messages flex-grow-1 d-flex justify-content-between">
            <div
                ref={div}
                className="flex-grow-1 d-flex justify-content-between flex-column overflow-hidden"
            >
                {participant &&
                    <div className="d-flex justify-content-between pe-3">
                        <div className="d-flex" ref={divHeader}>

                            <div className="me-3">
                                <a href={participant.url}>
                                    <img
                                        width="50"
                                        className="avatar-img"
                                        alt={userName}
                                        src={avatar}
                                    />
                                </a>
                            </div>
                            <div className="overflow-hidden d-flex flex-column justify-content-center">
                                <h6 className="font-weight-bold m-0 text-truncate overflow-hidden">
                                    <a href={participant.url}>
                                        {userName}
                                    </a>
                                    {isUserWatched && <span className="ms-2 badge bg-danger rounded-pill">User Watched</span>}
                                    {manageUserUrl && <span className="ms-2">[<a href={manageUserUrl}>manage</a>]</span>}
                                </h6>
                            </div>

                        </div>
                        <div className="d-flex justify-content-center flex-column">
                            <UserContextMenu id={participant.id} />
                        </div>
                    </div>
                }
                <div
                    style={{maxHeight: (height - (hHeight + fHeight + 25)) + 'px'}}
                    className="flex-grow-1 d-flex justify-content-end flex-column mb-3"
                >
                    <div
                        className="pe-3"
                        style={{ overflowY: 'auto' }}
                    >
                        {messages.map(item =>
                            <Message key={item.id} userId={user?.id} message={item} />
                        )}
                        <div ref={messagesEndRef} />
                    </div>
                </div>
                <div ref={divFooter}>
                    <MessageForm
                        id={id}
                        onChange={loadData}
                    />
                </div>
            </div>
            <div className="d-none d-xl-block flex-shrink-0 border-left ps-3" style={{width: '450px'}}>
                {threadable && thread?.threadable_type &&
                    <Threadable
                        user={user}
                        item={threadable}
                        type={thread.threadable_type}
                    />
                }
            </div>
        </div>
    )
}


const Thread = ({ match, history }) => {

    const { location } = useContext(AppContext)
    const id = match?.params?.id

    return (
        <>
            <div className="flex-grow-1 d-flex flex-column">
                <Header history={history} fluid={true} />
                <main className="py-4 flex-grow-1 d-flex">
                    <div className="container-fluid flex-grow-1 d-flex flex-column">
                        <div className="container flex-grow-1 d-flex flex-column">
                            <Breadcrumbs list={breadcrumbsBy(location, [
                                {url: '/account', title: 'Dashboard', tag: 'link'},
                                {url: '/account/messages', title: 'Inbox', tag: 'link'},
                                {title: 'Messages'}
                            ])} />
                            <Helmet><title>{'Message | ' + process.env.MIX_APP_NAME}</title></Helmet>

                            {id && <ThreadMessages id={id} />}
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </>
    )
}

export default Thread
